/**
 * 文件内包含一些常用正则表达式
 */

/** @description 验证文件名是否合法,不允许包含 \ / : * ? " < > | 等特殊字符 */
export const REGEXP_VALID_FILE_NAME = /^[^\\\/:*?"<>|]+$/
/** @description 包含文件名特殊字符,用于替换 */
export const REGEXP_REPLACE_FILE_NAME = /[\\\/:*?"<>|]/g
